import { Children, cloneElement } from 'react';

import { usePopoverContext } from './context';

import type { FC, ReactElement } from 'react';

export interface IsOpenProps {
  children: ReactElement | ReactElement[];
}

export const PopoverIsOpen: FC<IsOpenProps> = ({ children, ...props }) => {
  const { isOpen } = usePopoverContext();

  return (
    <>
      {Children.map(children, (child) =>
        cloneElement(child, {
          isOpen,
          ...props,
        })
      )}
    </>
  );
};
